import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { Lookup } from '../../../../shared-components/lookup/lookup.model';
import { LookupService } from '../../../../shared-components/lookup/lookup.service';
import { DataDefinition, DataDefinitionList } from '../../data-definition.model';
import { DataDefinitionService } from '../../data-definition.service';

@Component({
  selector: 'app-add-edit-data-definition',
  templateUrl: './add-edit-data-definition.component.html'
})
export class AddEditDataDefinitionComponent implements OnInit {
  dataDefList: DataDefinitionList;
  dataDef: DataDefinition[];
  selectedDataDef: DataDefinition;
  showUseForStateReporting: boolean;
  codeRequired: boolean;
  stateReportingCodes: Lookup[];
  errors: ErrorList[] = [];
  viewOnly: boolean;
  @ViewChild('codeRef', { read: ElementRef }) codeRef: ElementRef;
  @ViewChild('descriptionRef', { read: ElementRef }) descriptionRef: ElementRef;

  constructor(
    private lookupService: LookupService,
    private dataDefinitionService: DataDefinitionService,
    private dialog: MatDialogRef<AddEditDataDefinitionComponent>
  ) {
  }

  ngOnInit() {
    this.viewOnly = (this.dataDefList.LockSystemCodes && this.selectedDataDef.IsSysGen) ? true : false;
    this.showUseForStateReporting = this.dataDefList.ShowUsedForStateReporting;
    this.codeRequired = !this.dataDefList.CodeNotRequired;
    if (this.dataDefList.StateReportingType > 0) {
      this.lookupService.getStateReportingCodes(this.dataDefList.StateReportingType, 0, 'MO', false).subscribe(codes => {
        if (codes && codes.length > 0) {
          this.stateReportingCodes = codes;
        }
      });
    }
  }

  StateReportingChange() {
    this.selectedDataDef.StateIdentifier = '';
  }

  cancelClick() {
    this.dialog.close('cancel');
  }

  saveClick() {
    this.validate();
    if (this.errors.length == 0) {
      if (this.codeRequired) {
        const codeExists = this.dataDef.find(o => o.Code != null && o.Code.toUpperCase() == this.selectedDataDef.Code.toUpperCase() && o.Id != this.selectedDataDef.Id);
        if (codeExists) {
          this.errors.push({
            fieldName: 'Code',
            fieldRef: this.codeRef,
            errorMsg: 'Code already exists.'
          });
        } else {
          this.dialog.close('save');
        }
      }
      else {
        this.dialog.close('save');
      }
    }
  }

  validate() {
    this.errors = [];
    if (this.codeRequired && !this.selectedDataDef.Code) {
      this.errors.push({
        fieldName: 'Code',
        fieldRef: this.codeRef,
        errorMsg: 'is required.'
      });
    }
    if (!this.selectedDataDef.Description) {
      this.errors.push({
        fieldName: 'Description',
        fieldRef: this.descriptionRef,
        errorMsg: 'is required.'
      });
    }
  }
}
